import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Offers from "@/components/Offers";
import WhyUs from "@/components/WhyUs";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App bg-[#FAF8F5]">
      <Navbar />
      <Hero />
      <About />
      <Offers />
      <WhyUs />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
